/* ======================================================================== */
/* 5. PJAX Init New Page */
/* ======================================================================== */
function PJAXInitNewPage(data) {

	return new Promise(function (resolve, reject) {

		Promise.all([
			PJAXUpdateAdminBar(data),
			PJAXUpdateLanguageSwitcher(data),
			PJAXUpdateBodyClasses(data),
			PJAXUpdateHeaderClasses(data),
			PJAXUpdateHead(data),
			fontObserver()
		]).then(function () {

			var
				tl = new TimelineMax(),
				$nextContainer = $(data.next.container),
				$elementorSections = $nextContainer.find('.elementor-section'),
				$cf7Forms = $nextContainer.find('.wpcf7-form');

			tl
				.delay(0.25)
				.add(function () {

					// Elementor Pro sticky effects handling
					TweenMax.set($elementorSections, {
						clearProps: 'all',
						className: '-=elementor-sticky--active'
					});
					$nextContainer.find('.elementor-sticky__spacer').remove();

					// re-init Contact Form 7
					if (typeof wpcf7 !== 'undefined') {
						wpcf7.initForm($cf7Forms);
					}

					// re-init Contact Form 7 Conditional Fields Plugin
					if (typeof wpcf7cf !== 'undefined') {
						wpcf7cf.initForm($cf7Forms);
					}

					// clear & re-init ScrollMagic
					window.SMController.destroy(true);
					window.SMController = new ScrollMagic.Controller();

					// split text lines in new container
					doSplitText($nextContainer).then(setLines($nextContainer)).then(function () {

						// scroll to the top
						setTimeout(function () {
							scrollToVeryTop();
						}, 100);

						if (typeof window.elementorFrontend !== 'undefined') {
							elementorFrontend.init();
						}

						// re-init components
						initComponents($nextContainer);
						window.SMController.enabled(false);

						// update ad trackers
						PJAXUpdateTrackers();

					});

					// change header color if needed
					switch (data.next.namespace) {
						case 'light': {
							window.$header.removeClass('header_white').addClass('header_black');
							break;
						}
						case 'dark': {
							window.$header.removeClass('header_black').addClass('header_white');
							break;
						}
					}

					$nextContainer.removeClass('page-wrapper_hidden');

				})
				.add(function () {
					resolve(true);
				});

		});
	});

}
